import { render, staticRenderFns, recyclableRender, components } from "./everyday-practice.vue?vue&type=template&id=9f55c69c&scoped=true&"
var renderjs
import script from "./everyday-practice.vue?vue&type=script&lang=js&"
export * from "./everyday-practice.vue?vue&type=script&lang=js&"
import style0 from "./everyday-practice.vue?vue&type=style&index=0&id=9f55c69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f55c69c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/everyday-practice.vue"
export default component.exports